export enum ActionState {
    InProcess,
    Success,
    Fail,
    Undefined
 }